const moment = require('moment');

moment.locale('pl');

export default moment;
